import React from "react";

const Upload = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.71429 12V3.85L5.11429 6.45L3.71429 5L8.71429 0L13.7143 5L12.3143 6.45L9.71429 3.85V12H7.71429ZM2.71429 16C2.16429 16 1.69346 15.8042 1.30179 15.4125C0.910128 15.0208 0.714294 14.55 0.714294 14V11H2.71429V14H14.7143V11H16.7143V14C16.7143 14.55 16.5185 15.0208 16.1268 15.4125C15.7351 15.8042 15.2643 16 14.7143 16H2.71429Z"
        fill="#7BB25F"
      />
    </svg>
  );
};

export default Upload;
